import { Home, Building2, Briefcase, Package, Zap, ArrowRight } from "lucide-react";

const services = [
  { icon: Home, title: "Home Moves", href: "/home-moves", desc: "Full house removals with care and efficiency. We handle everything so you don't have to." },
  { icon: Building2, title: "Apartment Moves", href: "/apartment-moves", desc: "Lift-friendly, careful and quick moves for units and apartments." },
  { icon: Briefcase, title: "Office Relocations", href: "/office-relocations", desc: "Minimal downtime, maximum organisation. Your business keeps running." },
  { icon: Package, title: "Single Item Moves", href: "/single-item-moves", desc: "Got one heavy piece? We'll pick it up and deliver it safely." },
  { icon: Zap, title: "Same Day Moves", href: "/same-day-moves", desc: "Need to move today? Call us - we'll make it happen." },
];

const ServicesSection = () => (
  <section id="services" className="bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-dark text-center mb-4">
        Our Moving Services
      </h2>
      <p className="text-center text-muted-foreground mb-14 max-w-lg mx-auto">
        Whatever you need moved, we've got you covered.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((s) => (
          <a
            key={s.title}
            href={s.href}
            aria-label={`View ${s.title} service details`}
            className="group bg-card rounded-xl p-7 hover:shadow-lg hover:-translate-y-0.5 transition-all border border-transparent hover:border-[#1a1a1a]/10 block"
          >
            <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center mb-5">
              <s.icon className="w-6 h-6 text-dark" />
            </div>
            <h3 className="text-xl font-bold text-dark mb-2">{s.title}</h3>
            <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-dark font-bold text-sm">
              View
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
